import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs/internal/Subscription';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { Tables } from '../../entities/tables';
import { IMenuItem } from 'src/app/admin/core/interfaces/IMenu';
import { EntityService } from 'src/app/admin/core/services/entity.service';
import {
  BackofficeRestrictions,
  ExtranetRestrictions,
  User,
} from '../../entities/authentication/user';
import { Role } from '../../enums/user-roles';
import { IDroit } from 'src/app/admin/core/interfaces/IDroit';
import { ExtractEntityNamePipe } from '../../core/pipes/entitynamepipe';
import { Entite } from '../../entities/entite';
import { DeleteReq } from '../../entities/deleteReq';
import { DiaologHostComponent } from '../dialogs/dialog-host/dialog-host';
import { TabService } from '../../services/tab.service';
import {
  RestrictionEntite,
  RestrictionsComponent,
} from '../dialogs/restrictions/restrictions/restrictions.component';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, of, switchMap } from 'rxjs';
import { UserService } from 'src/app/admin/core/services/user.service';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';

import { Language } from '../../entities/language';
import { DynamicDocumentInfoService } from '../../services/dynamic-document-info.service';
import { DynamicDocumentInfo } from '../../entities/dynamic-document';
import { AlertService } from '../../services/alert-service';
import { RoleService } from 'src/app/admin/core/services/role.service';
export class FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  selected: boolean;
  parentId: string;
  entityName: string;
  droitTitle: string;
  typeName: string;
  icon: string;
  is_custom_icon: boolean;
  filterappliques: any;
  listedechamps: any[];
  // Add the parentId propIerty

  constructor(
    expandable: boolean,
    name: string,
    level: number,
    selected: boolean,
    parentId: string,
    icon: string,
    entityName: string,
    is_custom_icon: boolean,
    droitTitle: string,
    typeName: string,
    filresappliques: string,
    listedechamps: string[]
  ) {
    this.expandable = expandable;
    this.name = name;
    this.level = level;
    this.selected = selected;
    this.parentId = parentId;
    this.entityName = entityName;
    this.droitTitle = droitTitle;
    this.typeName = typeName;
    this.icon = icon;
    this.is_custom_icon = is_custom_icon;
    this.filterappliques = filresappliques;
    this.listedechamps = listedechamps;
  }
}

@Component({
  selector: 'app-admin-user-group-parameter',
  templateUrl: './admin-user-group-parameter.component.html',
  styleUrls: ['./admin-user-group-parameter.component.css'],
})
export class AdminUserGroupParameterComponent implements OnInit, OnDestroy {
  @Input() public tab: Tables = new Tables();
  @Input() public value: any;
  datasource = new MatTableDataSource<any>();
  menuDynamic: any;
  datasourceEntities = new MatTableDataSource<any>();

  private _transformer = (node: any, level: number) => {
    return {
      expandable: !!node?.children && node?.children.length > 0,
      name: node?.text,
      level: level,
      parentId: node?.parentId,
      icon: node?.icon,
      is_custom_icon: node?.is_custom_icon,
      entityName: node?.entityName,
      droitTitle: node?.droitTitle,
      typeName: node?.typeName,
      selected: node?.selected || false,
      filterappliques: node?.filterappliques,
      listedechamps: node?.listedechamps, // Set the selected property
    };
  };

  private _transformerdroit = (node: any, level: number) => {
    return {
      expandable: !!node?.children && node?.children.length > 0,
      name: node.text,
      level: level,
      parentId: node?.parentId,
      icon: node?.icon,
      entityName: node?.entityName,
      droitTitle: node?.droitTitle,
      typeName: node?.typeName,
      is_custom_icon: node?.is_custom_icon,
      selected: node?.selected || false,
      filterappliques: node?.filterappliques,
      listedechamps: node?.listedechamps,
    };
  };
  treeControl = new FlatTreeControl<FlatNode>(
    (node) => node?.level,
    (node) => node?.expandable
  );
  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node?.level,
    (node) => node?.expandable,
    (node) => node?.children
  );

  droittreeControl = new FlatTreeControl<FlatNode>(
    (node) => node?.level,
    (node) => node?.expandable
  );
  droittreeFlattener = new MatTreeFlattener(
    this._transformerdroit,
    (node) => node?.level,
    (node) => node?.expandable,
    (node) => node?.children
  );
  treeFlatDataSource = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );

  droitTreeFlatDataSource = new MatTreeFlatDataSource(
    this.droittreeControl,
    this.droittreeFlattener
  );

  hasTreeFlat: boolean = false;

  hasChild = (_: number, node: FlatNode) => node.expandable;

  selection = new SelectionModel<any>(true, []);
  public entityNamePipe: ExtractEntityNamePipe;
  entites: RestrictionEntite[] = [
    { entite: 'role', label: 'Rôle & profil', isDynamic: false },
    { entite: 'parametre', label: 'Parametre', isDynamic: false },
    // { entite: 'dynamic_document_info', label: 'Entités dynamiques', isDynamic: false },
  ];
  selectedEntity = this.entites[0];

  champs: any = [];

  utilisateur: string;
  @Input() public usertab: Tables = new Tables();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  listedechamps: any[] = [
    'select',
    'nom',
    'firstname',
    'lastname',
    'email',
    'prenom',
  ];
  entities: Entite[] = [];
  roleDefault: Role = new Role();
  temprole: Role = new Role();
  pageIndex: number = 0;
  pageSize: number = 25;
  totalElements: number = 0;
  selectedMenu: any;
  nomsDeChamps: string[] = [
    'Table',
    'Lecture',
    'Modification',
    'Création',
    'Suppression',
    'Archivage',
  ];
  status: string[] = ['Actif', 'Inactif'];
  clickSelection = new Set<any>();
  title: string;
  creer: boolean = false;
  info: boolean = false;
  tabList: string[] = [];
  tabs: string[] = [];
  deleteReq = new DeleteReq();

  selected = new FormControl();
  edition: boolean = false;
  lecture: boolean = true;
  subscriptions: Subscription[] = [];

  menu: IMenuItem[] = [];
  dynamicMenu: IMenuItem[] = [];

  droit: IDroit[] = [];
  rightsDynamic: IDroit[] = [];
  role: Role = new Role();
  user: User;
  users: User[] = [];
  motCle: string;
  roleusers: User[] = [];
  extranetRestrictions: ExtranetRestrictions = new ExtranetRestrictions();
  backofficeRestrictions: BackofficeRestrictions = new BackofficeRestrictions();
  languages: Language[] = [];
  dynamicMenus: IMenuItem[] = [];

  public fonctionsback: any = [
    'Lecture/Affichage dans le menu',
    'Création',
    'Modification',
    'Suppression unitaire',
    'Modifier le template',
    'Génération de PDF',
    'Génération de QR Code',
    'Filtre dans le tableau de visualisation',
    'Suppression en masse',
    'Recherche par mots clés',
    'Import',
    'Export',
    'Visualisation de fiches en masse',
    'Gestion des visualisations',
    'Duplications de fiches de données'
  ];

  dynamicDocuments: DynamicDocumentInfo[] = [];

  constructor(
    private httpClientService: HttpclientService,
    private dash: DashboardComponent,
    private dialog: MatDialog,
    private alertService: AlertService,
    private myTableService: TabService,
    private dynamicDocumentInfoService: DynamicDocumentInfoService,
    public userService: UserService,
    private entiteService: EntityService,
    private roleService: RoleService
  ) {}

  ngOnInit(): void {
    this.loadDynamicDocuments()
      .pipe(
        switchMap(() => {
          return this.loadMenuDynamic();
        })
      )
      .subscribe(() => {
        this.InitializeRoleObject();
      });

    this.tab.droitTitle = 'Rôles et profils';
    if (this.tab?.value === 'edition') {
      this.modeEdition();
    } else if (this.tab?.value === 'lecture') {
      this.tab.listedechamps = this.listedechamps;

      this.edition = false;
      this.lecture = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {}

  InitializeRoleObject() {
    if (this.tab?.id) {
      let subs = this.httpClientService
        .getObjet(this.tab.entite, this.tab.id)
        .subscribe((res) => {
          this.role = res;

          if (!this.role.backofficeRestrictions) {
            this.role.backofficeRestrictions = new BackofficeRestrictions();
            this.role.backofficeRestrictions.champs = [];
          }
          if (this.role.extranetRestrictions)
            this.extranetRestrictions = this.role.extranetRestrictions;
          if (this.role.backofficeRestrictions) {
            this.backofficeRestrictions = this.role.backofficeRestrictions;
          }
          this.datasourceEntities.data = this.role.entities;

          if (
            !this.role?.backofficeRestrictions?.droits ||
            this.role?.backofficeRestrictions?.droits.length == 0
          ) {
            this.loadDroits();
          } else {
            this.updateDroitsEdition();
          }
          if (
            !this.role?.backofficeRestrictions?.menu ||
            this.role?.backofficeRestrictions?.menu.length == 0
          ) {
            this.loadMenu();
          } else {
            this.updateMenusEdition();
          }
          if (this.users.length == 0) {
            this.loadUsers();
          }

          this.loadEntite('');
        });

      this.subscriptions.push(subs);
    } else {
      // CreationMode
      this.loadUsers();
      this.loadMenu();
      this.loadEntite('');
      this.loadDroits();
    }
  }
  modeEdition() {
    this.temprole = this.role;
    this.edition = true;
    this.lecture = false;
  }

  // setDynamicMenu() {
  //   this.menu = this.role?.backofficeRestrictions?.menu;
  //   const el = this.menu?.find((el) => el?.icon == 'arborescence');

  //   let menus: IMenuItem[] = [];
  //   for (let i = 0; i < this.dynamicDocuments.length; i++) {
  //     let dynDoc = this.dynamicDocuments[i];
  //     let menu = new IMenuItem();
  //     menu.selected = true;
  //     menu.isDynamic = true;
  //     menu.id = dynDoc.id;
  //     menu.text = this.dynamicDocumentInfoService.getLabel(dynDoc);
  //     menu.entityName = dynDoc.documentName;
  //     menu.parentId = el?.text ? el?.text : 'checkParentIdValue';
  //     menus.push(menu);
  //   }
  //   if (!menus) {
  //     menus = [];
  //   }
  //   this.dynamicMenu.push(...menus);

  //   if (el) {
  //     let entities = el?.children.map((el) => el?.entityName);
  //     let filterDynamicMenu = this.dynamicMenu.filter(
  //       (item) => !entities.includes(item?.entityName)
  //     );
  //     filterDynamicMenu.forEach(
  //       (item) =>
  //         (item.parentId = el.text
  //           ? el.text
  //           : el.droitTitle
  //           ? el.droitTitle
  //           : el.entityName)
  //     );
  //     el?.children?.unshift(...filterDynamicMenu);
  //   }

  //   this.checkForDeletedDynamicDocumentsMenu();

  //   this.treeFlatDataSource.data = this.menu;
  // }

  checkForDeletedDynamicDocumentsMenu() {
    if (this.dynamicDocuments.length > 0) {
      const el = this.menu.find((el) => el.icon == 'arborescence'); // Gestion de l'arborescence

      if (el) {
        let entities = el?.children.filter((el) => el.isDynamic); // Check sur les entités dynamiques enregistrées dans le menu

        for (let i = 0; i < entities.length; i++) {
          let entity = entities[i];
          let matchingDoc = this.dynamicDocuments.find(
            (doc) => doc.documentName === entity.entityName
          ); // On vérifie que l'entité est présente dans les doc dynamiques

          if (!matchingDoc) {
            // Si elle n'est pas présente, alors on la retire de la liste
            el.children = el.children.filter(
              (menuItem) => menuItem.entityName !== entity.entityName
            );
          }
        }
      }
    }
  }

  checkForDeletedDynamicDocumentsRights() {
    if (this.dynamicDocuments.length > 0) {
      let dynamicRights = this.droit.filter((el) => el.isDynamic); // Tous les droits des documents dynamiques
      for (let i = 0; i < dynamicRights.length; i++) {
        let right = dynamicRights[i];
        let matchingRight = this.dynamicDocuments.find(
          (doc) => doc.documentName === right.entityName
        ); // On vérifie que l'entité est présente dans les doc dynamiques

        if (!matchingRight) {
          // Si elle n'est pas présente, alors on la retire de la liste
          this.droit = this.droit.filter(
            (r) => r.entityName !== right.entityName
          );
        }
      }
    }
  }

  // updateDroitsEdition() {
  //   if (this.role.backofficeRestrictions?.droits) {
  //     let newItems = this.rightsDynamic.filter((item: any) =>
  //       this.role.backofficeRestrictions?.droits.every(
  //         (existingItem: any) => existingItem.entityName !== item.entityName
  //       )
  //     );
  //     this.droit = [...newItems, ...this.role.backofficeRestrictions?.droits];
  //     this.droitTreeFlatDataSource.data = this.droit;
  //   }
  // }

  updateDroitsEdition() {
    if (this.role.backofficeRestrictions?.droits) {
      this.rightsDynamic.forEach((item) => {
        const matchingItemIndex =
          this.role.backofficeRestrictions.droits.findIndex(
            (existingItem) =>
              existingItem.text.toLocaleLowerCase() ===
              item.text.toLocaleLowerCase()
          );
        if (matchingItemIndex !== -1) {
          const matchingItem =
            this.role.backofficeRestrictions.droits[matchingItemIndex];
          // Add items from the children of 'item' to the children of 'matchingItem'
          item.children.forEach((child) => {
            // Check if the child already exists in matchingItem.children
            const existingChildIndex = matchingItem.children.findIndex(
              (existingChild) =>
                existingChild.text.toLocaleLowerCase() ===
                child.text.toLocaleLowerCase()
            );
            if (existingChildIndex === -1) {
              // If not, add the child to matchingItem.children
              matchingItem.children.push(child);
            }
          });
          // Replace the updated item in the backofficeRestrictions.menu array
          this.role.backofficeRestrictions.droits[matchingItemIndex] =
            matchingItem;
        }
      });

      // Now, newItems will contain items from this.role.backofficeRestrictions.menu excluding the ones that were updated
      let newItems = this.rightsDynamic.filter((existingItem) =>
        this.role.backofficeRestrictions.droits.every(
          (item) => item.text !== existingItem.text
        )
      );

      // Combine newItems with items from this.dynamicMenus
      this.droit = [...newItems, ...this.role.backofficeRestrictions?.droits];
      this.droitTreeFlatDataSource.data = this.droit;
    }
  }
  // updateMenusEdition() {
  //   // for each item in this.role.backofficeRestrictions?.menu find the corresponding item in  this.dynamicMenus replace
  //   if (this.role.backofficeRestrictions?.menu) {
  //     let newItems = this.dynamicMenus.filter((item: any) =>
  //       this.role.backofficeRestrictions?.menu.every(
  //         (existingItem: any) => existingItem.text !== item.text
  //       )
  //     );
  //     ///

  //     this.menu = [...newItems, ...this.role.backofficeRestrictions?.menu];
  //     this.treeFlatDataSource.data = this.menu;
  //   }
  // }
  updateMenusEdition() {
    if (this.role.backofficeRestrictions?.menu) {
      this.dynamicMenus?.forEach((item) => {
        const matchingItemIndex =
          this.role.backofficeRestrictions.menu.findIndex(
            (existingItem) => existingItem.text === item.text
          );
        if (matchingItemIndex !== -1) {
          const matchingItem =
            this.role.backofficeRestrictions.menu[matchingItemIndex];
          // Add items from the children of 'item' to the children of 'matchingItem'
          item.children?.forEach((child) => {
            // Check if the child already exists in matchingItem.children
            const existingChildIndex = matchingItem.children?.findIndex(
              (existingChild) => existingChild.text === child.text
            );
            if (existingChildIndex === -1) {
              // If not, add the child to matchingItem.children
              matchingItem.children?.push(child);
            }
          });
          // Replace the updated item in the backofficeRestrictions.menu array
          this.role.backofficeRestrictions.menu[matchingItemIndex] =
            matchingItem;
        }
      });

      // Now, newItems will contain items from this.role.backofficeRestrictions.menu excluding the ones that were updated
      let newItems = this.dynamicMenus?.filter(
        (existingItem) =>
        this.role.backofficeRestrictions.menu.every(
            (item) => item.text  !== existingItem.text
          )
      );

      // Combine newItems with items from this.dynamicMenus
      this.menu = [...newItems, ...this.role.backofficeRestrictions?.menu];
      this.treeFlatDataSource.data = this.menu;
    }
  }

  loadDynamicRights(dynamicdocs: DynamicDocumentInfo[]) {
    for (let i = 0; i < dynamicdocs.length; i++) {
      let dynDoc = dynamicdocs[i];

      let children = this.fonctionsback.map((el: any) => {
        return {
          text: el,
          selected: true,
          parentId: this.dynamicDocumentInfoService.getLabel(dynDoc),
        };
      });

      let right: any = {};
      right.selected = true;
      right.isDynamic = true;
      right.label = this.dynamicDocumentInfoService.getLabel(dynDoc);
      right.text = this.dynamicDocumentInfoService.getLabel(dynDoc);
      right.children = children;
      right.entityName = dynDoc.documentName;
      right.url = null;
      right.id = dynDoc.id;
      right.title = null;
      right.subItems = null;
      right.parentId = null;
      this.rightsDynamic.push(right);
    }
  }

  loadDynamicDocuments(): Observable<void> {
    return new Observable<void>((observer) => {
      this.dynamicDocumentInfoService
        .findAll()
        .then((docs) => {
          this.dynamicDocuments = docs;
          for (let i = 0; i < this.dynamicDocuments?.length; i++) {
            let entite: RestrictionEntite = {
              entite: this.dynamicDocuments?.[i].documentName,
              label: this.dynamicDocumentInfoService.getLabel(
                this.dynamicDocuments[i]
              ),
              isDynamic: true,
            };
            this.entites.push(entite);
          }

          this.entites.push(...this.entites);
          this.loadDynamicRights(this.dynamicDocuments);
          observer.next(); // Emit a value to indicate completion
          observer.complete(); // Complete the observable
        })
        .catch((error) => {
          observer.error(error); // Emit an error if loading fails
        });
    });
  }

  ouvrirOnglet(value: any) {
    const tab = new Tables();
    tab.title = 'utilisateur';
    tab.entite = 'user';
    tab.title = 'utilisateur';
    tab.value = 'lecture';
    tab.id = value.id;
    this.dash.ajouterUnEntite(tab);
  }
  selectAllDroits() {}

  pickDroitItem(index: number, event: any) {
    if (this.droit[index]?.children) {
      this.droit[index].children.map((el) => {
        el.selected = event?.target?.checked;
      });
    }
  }
  enregistrer() {
    let roleUrl = '/role/add';
    this.role.extranetRestrictions = this.extranetRestrictions;
    this.role.backofficeRestrictions = this.backofficeRestrictions;
    this.role.backofficeRestrictions.droits = this.droit;
    this.role.backofficeRestrictions.menu = this.menu;
    this.role.entities = this.datasourceEntities.data;

    this.selection.selected.map((user) => this.role.users.push(user));

    this.role.nom = this.role?.name?.trim();

    this.httpClientService.post(this.role, roleUrl).subscribe((data) => {
      this.role = data;

      this.role.nom = this.role.name;
      this.dash.changeNameOrTitleAfterSave(
        this.tab,
        this.myTableService.getTabTitle(data, this.languages, this.tab.entite)
      );
      this.myTableService.updateOrAddItem(this.role, this.tab.entite);
    });

    this.lecture = true;
    this.edition = false;
    this.tab.value = 'lecture';
    this.tab.dialogName = 'popup';
    this.tab.deleteReq = this.deleteReq;
    if (this.role.id === undefined) {
      this.tab.msg = `Un nouveau group d'utilisateur a été créé avec le nom :  ${this.role.name}`;
      return false;
    } else {
      this.tab.msg = 'Vos modifications ont été enregistrées avec succès';
    }
    let dialogRef = this.dialog.open(DiaologHostComponent, {
      panelClass: 'filtre-dialog-component',
      data: {
        title: 'Attention !',
        msg: this.tab.msg,
        tab: this.tab,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.alertService
        .confirmDialog({
          title: 'Rechargement de la page',
          confirmText: 'oui',
          cancelText: 'non',
          message: "Rafraichir l'onglet ?",
        })
        .pipe(
          map((res) => {
            if (res) {
              window.location.reload();
            }
          })
        )
        .subscribe();
    });
    return true;
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.datasource.data.length;
    return numSelected === numRows;
  }
  checkboxLabel(element?: any): string {
    if (!element) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(element) ? 'deselect' : 'select'} row ${
      element.id + 1
    }`;
  }

  loadUsers() {
    let userUrl = `user/${this.pageIndex}/${this.pageSize}`;
    this.httpClientService.get(userUrl).subscribe((data) => {
      this.users = data.users;
      this.users.forEach((x) => {
        x.nom = x.lastname;
        x.prénom = x.firstname;
        x.password = '';
      });
      this.datasource.data = this.users;
      this.roleusers = this.users;
      this.roleusers = this.roleusers.filter((x) =>
        this.role?.users?.includes(x.id)
      );
    });
  }

  selectAll(colonne: string) {
    if (colonne.includes('droit')) {
      if (colonne.includes('menu')) {
        // menu
        let full: boolean =
          this.menu.length ===
          this.menu.filter((el) => el.selected == true).length;
        this.menu.map((el) => {
          el.selected = !full;
          if (el.subItems || el.children) {
            let arr = el.subItems ? el.subItems : el.children;
            arr.map((ell) => (ell.selected = !full));
          }
        });
      } else {
      }
    } else {
      let full: boolean =
        this.datasourceEntities.data.length ===
        this.datasourceEntities.data.filter((el) => el[colonne] == true).length;
      this.datasourceEntities.data.map((el) => (el[colonne] = !full));
    }
  }

  pickMenuItem(index: number, event: any) {
    if (this.menu[index]?.children) {
      this.menu[index].children.map((el) => {
        el.selected = event?.target?.checked;
      });
    }
  }

  pickSubMenuItem(index: number, event: any, name: string) {
    this.selectedMenu = name;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.datasource.data);
  }
  rafraichir() {
    this.temprole = this.role;
    this.role = this.roleDefault;
  }
  annuler() {
    this.lecture = true;
    this.edition = false;
    this.role = this.temprole;
  }

  filtreMotCles(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  loadMenu() {
    // load static menu from static file

    this.httpClientService
      .get('menu/static')
      .pipe(
        map((res) => {
          this.menu = [...this.dynamicMenus,...res, ];
          this.treeFlatDataSource.data = this.menu;
        })
      )
      .subscribe();
    // load dynamic menu from
  }
  loadMenuDynamic(): Observable<void> {
    const menuUrl = 'menu/';
    return this.httpClientService.get<any[]>(menuUrl).pipe(
      catchError((error) => {
        console.error('Error fetching menu:', error);
        return of([]);
      }),
      map((items) =>
        items.filter((item: any) => item.isDynamic && !item.parentId)
      ), // retrives paent menus
      map((filteredItems) => {
        this.dynamicMenus = filteredItems;
        return;
      })
    );
  }

  loadDroits() {
    this.httpClientService
      .get(`assets/mock-apis/droits.static.json`)
      .pipe(
        map((res) => {
          this.droit = [...res, ...this.rightsDynamic];
          this.droitTreeFlatDataSource.data = this.droit;
          this.role.backofficeRestrictions.droits = this.droit;
        })
      )
      .subscribe();
  }

  setExtranetRestrictions(
    propriete: 'menu' | 'champs' | 'fonctions',
    event: any
  ) {
    let reg = new RegExp(' - |,', 'g');
    this.extranetRestrictions[propriete] = event.target.value
      ?.split(reg)
      .map((el: any) => el.trim());
  }

  openRestrictions() {
    let dialogRef = this.dialog.open(RestrictionsComponent, {
      data: { restrict: this.extranetRestrictions, user: this.role },
    });

    dialogRef.updateSize('80vw', '100vh');
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'save') this.enregistrer();
    });
  }

  openRestrictionsBackoffice() {
    let dialogRef = this.dialog.open(RestrictionsComponent, {
      data: {
        restrict: this.backofficeRestrictions,
        user: this.role,
        back: true,
      },
    });

    dialogRef.updateSize('80vw', '100vh');
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'save') this.enregistrer();
    });
  }
  setBackofficeRestrictions(
    propriete: 'menu' | 'champs' | 'fonctions',
    event: any
  ) {
    let reg = new RegExp(' - |,', 'g');
    this.backofficeRestrictions[propriete] = event.target.value
      ?.split(reg)
      ?.map((el: any) => el.trim());
  }

  openBackofficeRestrictions() {
    let dialogRef = this.dialog.open(RestrictionsComponent, {
      data: {
        restrict: this.backofficeRestrictions,
        user: this.role,
        back: true,
      },
    });

    dialogRef.updateSize('80vw', '100vh');
    dialogRef.afterClosed().subscribe((res) => {
      if (res == 'save') this.enregistrer();
    });
  }

  supprimer() {
    let roleUrl = 'user/role/bulkDelete';
    let subs = this.httpClientService
      .post(this.role, roleUrl)
      .subscribe((data) => {});
  }
  public get roleHasUser() {
    if (this.role.users != null) {
      return !!this.role.users.length;
    }
    return false;
  }

  public handleSelectUser(e: any, user: User) {
    if (e.checked) {
      if (this.role.users == null) this.role.users = [];
      if (this.role.users.indexOf(user.id) === -1)
        this.role.users.push(user.id);
    } else {
      const index = this.role.users.findIndex((userId) => userId === user.id);

      if (index !== -1) {
        this.role.users.splice(index, 1);
      }
    }
  }
  public isSelected(element: any) {
    if (this.role.users != null) {
      let index = this.role.users.findIndex((userId) => userId === element.id);

      return index !== -1 ? true : false;
    }
    return false;
  }

  suppressiondemasse() {
    this.deleteReq.idList.push(this.tab.id);

    this.totalElements = this.tab.totalElements;
    this.tab.dialogName = 'supprime';
    this.tab.deleteReq = this.deleteReq;

    this.tab.msg = `Voulez-vous vraiment supprimer les enregistrements`;
    let dialogRef = this.dialog.open(DiaologHostComponent, {
      panelClass: 'filtre-dialog-component',
      data: {
        title: 'Confirmation de la suppression',
        msg: `Voulez-vous vraiment supprimer les enregistrements`,
        tab: this.tab,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dash.openPrev(this.tab);
    });
  }
  ngOnDestroy() {
    this.subscriptions.forEach((element) => {
      element.unsubscribe();
    });
  }
  async loadEntite(event: any) {
    if (event?.value) {
      let ent = this.entites.find((el) => el.entite == event?.value);

      if (ent) {
        this.selectedEntity = ent;
      }
    }

    if (this.selectedEntity) {
      if (this.selectedEntity.isDynamic) {
        let doc = this.dynamicDocuments.find(
          (el) => el.documentName == this.selectedEntity.entite
        );
        if (doc) this.loadDynamicFields(doc);
      } else {
        try {
          const res = await this.entiteService.recouperChampsdEntite(
            this.selectedEntity.entite
          );
          if (res) {
            this.champs = res;
            this.entiteService.setReqMap(this.selectedEntity.entite, res);
          }
        } catch (error) {
          this.champs = [];
          throw error;
        }
      }
    } else {
      this.champs = [];
    }
  }

  loadDynamicFields(doc: DynamicDocumentInfo) {
    this.champs = [];
    doc.fields.forEach((f) => {
      let field = {
        label: { fr_FR: this.dynamicDocumentInfoService.getFieldLabel(f) },
        modificateur: 2,
        multilangue: f.isMultilingual,
        nom: f.name,
        id: f.id,
      };

      this.champs.push(field);
    });
  }

  pickChampItem(entite: any) {
    this.selectedEntity = entite;
    this.loadEntite('');
  }

  isIn(ref: any): boolean {
    ref = `${this.selectedEntity.entite}:${ref}`;
    return this.backofficeRestrictions?.champs?.includes(ref);
  }

  selectAllFields() {
    const allFieldsRef = this.champs.map(
      (champ: any) => `${this.selectedEntity.entite}:${champ.nom}`
    );
    this.backofficeRestrictions.champs = [
      ...new Set([...this.backofficeRestrictions.champs, ...allFieldsRef]),
    ];
  }

  removeAllFields() {
    const allFieldsRef: string[] = this.champs.map(
      (champ: any) => `${this.selectedEntity.entite}:${champ.nom}`
    );
    this.backofficeRestrictions.champs =
      this.backofficeRestrictions.champs.filter(
        (ref) => !allFieldsRef.includes(ref)
      );
  }

  select(field: string) {
    let reff = `${this.selectedEntity.entite}:${field}`;

    if (this.isIn(field)) {
      this.backofficeRestrictions.champs =
        this.backofficeRestrictions.champs.filter((el: any) => el != reff);
    } else {
      if (this.backofficeRestrictions.champs == null)
        this.backofficeRestrictions.champs = [];
      this.backofficeRestrictions.champs.push(reff);
    }
  }

  onSelectedCheckboxesChange(selectedItems: any[]): void {
    // Handle the selectedItems data as needed, for example, save it to the database
    this.menu = selectedItems;
  }

  selectedDroitChange(selectedItems: any[]): void {
    // Handle the selectedItems data as needed, for example, save it to the database
    this.droit = selectedItems;
  }
}
